module.exports = __webpack_public_path__ + "6de4b58929346d0aba5c62feb473974c.svg";